import partition from 'hs-lodash/partition';
// @ts-expect-error untyped module reference-resolvers
import { OWNER } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { HUBSPOT_OWNER } from 'automation-ui-action-features/object-type-properties/InternalPropertyDefaults';
import { convertToAddonPropertyOption } from 'automation-ui-action-features/object-type-properties/propertyUtils';
import { CHECKBOX } from 'customer-data-objects/property/PropertyFieldTypes';
const getProperties = ({
  properties
}) => properties;
const flattenProperties = (allProperties, properties) => allProperties.concat(properties);
const isNotHidden = ({
  hidden
}) => !hidden;
const isNotMultiSelect = ({
  fieldType
}) => fieldType !== CHECKBOX;
const isOwnerReferencedObjectType = ({
  referencedObjectType
}) => referencedObjectType === OWNER;
const moveOptionsToTop = (propertyNames, allOptions) => {
  const [pinnedOptions, restOptions] = partition(allOptions, option => propertyNames.includes(option.value));
  return pinnedOptions.concat(restOptions);
};
export const getOwnerPropertyOptions = ({
  dataSensitivityAllowlist,
  propertiesByGroup,
  objectTypeId,
  enforceFlp,
  requiredPermissionLevel,
  includeMultiSelectProperties
}) => {
  const visibleOwnerProperties = propertiesByGroup.map(getProperties).reduce(flattenProperties, []).filter(isNotHidden).filter(isOwnerReferencedObjectType);
  const selectedOwnerProperties = includeMultiSelectProperties ? visibleOwnerProperties : visibleOwnerProperties.filter(isNotMultiSelect);
  const selectOptions = selectedOwnerProperties.map(property => convertToAddonPropertyOption({
    property,
    objectTypeId,
    enforceFlp,
    requiredPermissionLevel,
    dataSensitivityAllowlist
  }));
  return moveOptionsToTop([HUBSPOT_OWNER], selectOptions);
};